import { RegistrationBlock } from './Shared';
import { useTokenViewContext } from '../TokenViewContext.js';
import styles from '../index.module.less';

import { Card, Col, Divider, Logo, Row } from '$HVUI';
import VaccinationCourse from '$Patient/Pages/Vaccinations/VaccinationCourse.jsx';
import { flexibleDateString, fullNameFromProfile } from '$Utils';

const VaccineDisplay = props => {
    const { vaccinations, visit, token } = props;
    const { birthdate } = useTokenViewContext();
    const { first_name, last_name } = visit;

    const openBeacon = e => {
        e.preventDefault();
        window.Beacon?.('identify', {
            vaccinationToken: token,
            errorType: 'Invalid vaccine information sent via API'
        });
        const prefill = {
            name: `${first_name} ${last_name}`,
            text: `There was an error loading my vaccination record. First name ${first_name}, last name ${last_name}, birthdate ${birthdate}.`
        };
        window.Beacon?.('prefill', prefill);
        window.Beacon?.('open');
    };

    //If we don't have at least one vaccination, something is wrong.
    if (!vaccinations || vaccinations.length == 0) {
        return (
            <div className={styles['wrapper']}>
                <Card className={styles['card']}>
                    <h1>Sorry, an error occurred.</h1>
                    <p>
                        Please{' '}
                        <button className="button-link" onClick={openBeacon}>
                            click here to contact our support team for
                            assistance.
                        </button>
                    </p>
                </Card>
            </div>
        );
    }

    const sortedVaccinations = vaccinations.sort(
        (a, b) =>
            new Date(b.vaccination_administration_datetime) -
            new Date(a.vaccination_administration_datetime)
    );
    const conditionSlugs = Array.from(
        new Set(sortedVaccinations.map(v => v.vaccine.condition_slug))
    );

    return (
        <div className={styles['wrapper-vaccination']}>
            <div className={styles['page-vaccination']}>
                <div
                    style={{
                        padding: '16px 18px 1px 18px',
                        maxWidth: '720px',
                        margin: 'auto'
                    }}
                >
                    <Row style={{ margin: '6px 9px' }}>
                        <Col span={12}>
                            <Logo style={{ width: '184px' }} />
                        </Col>
                        <Col span={12} />
                    </Row>
                    <Divider className={styles['logo-divider']} />
                    <h1
                        id="exp-vaccination-name"
                        className={styles['name-label']}
                    >
                        {fullNameFromProfile(visit)}
                    </h1>
                    <h2
                        id="exp-vaccination-dob"
                        className={styles['dob-label']}
                    >
                        Date of birth:{' '}
                        {flexibleDateString(visit.birthdate, null, 'MES')}
                    </h2>
                </div>

                {conditionSlugs.map(slug => {
                    const {
                        vaccine: { condition_label }
                    } = vaccinations.find(
                        v => v.vaccine.condition_slug === slug
                    );
                    return (
                        <VaccinationCourse
                            key={condition_label}
                            isLoggedIn={false}
                            me={visit}
                            vaccinations={vaccinations}
                            conditionLabel={condition_label}
                            conditionSlug={slug}
                        />
                    );
                })}
                <div className={styles['registration-block']}>
                    <RegistrationBlock {...props} isVaccine={true} />
                </div>
            </div>
        </div>
    );
};

export default VaccineDisplay;
